import { render, staticRenderFns } from "./PasoTresComponent.vue?vue&type=template&id=0a391bb1&scoped=true"
import script from "./PasoTresComponent.vue?vue&type=script&lang=js"
export * from "./PasoTresComponent.vue?vue&type=script&lang=js"
import style0 from "./PasoTresComponent.vue?vue&type=style&index=0&id=0a391bb1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a391bb1",
  null
  
)

export default component.exports